import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Table, Icon, Loader} from 'semantic-ui-react';
import {Field, formValueSelector} from 'redux-form';
import {tabKeyCode, enterKeyCode} from '../../../../common/constants/keyCodes';
import {toInteger} from '../../../../common/util/fieldsNormalization';
import {warehouses} from '../../../../common/dictionaries/parameters';
import {InputField} from '../../../../common/components/form';
import {stopEvent} from '../../../../common/util/event';
import {SCANNING_FORM} from '../../../../common/forms';
import {Actions} from '../../../../common/actions';
import PendingModal from '../modals/pendingModal';

class ScanningTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'wasReplacementPartCodeChecked': false,
      'pendingModalOpen': false,
    };

    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.selectCode = this.selectCode.bind(this);
  }

  componentDidUpdate(prevProps) {
    const {wasReplacementPartCodeChecked} = this.state;
    const {currentItem, items} = this.props;

    if (!items[currentItem]) {
      return;
    }

    if (
      prevProps.items[currentItem] !== items[currentItem].replacementPartCodeChecked &&
      !wasReplacementPartCodeChecked
    ) {
      this.setState({'wasReplacementPartCodeChecked': true}, () => {
        const element = document.getElementsByName(`items[${currentItem}].replacementPartQuantity`)[0];
        if (element) {
          element.focus();
        }
      });
    }
  }

  onSequenceCodeInputKeyDown(index, event) {
    if (!(event.keyCode === tabKeyCode || event.keyCode === enterKeyCode)) {
      return;
    }

    stopEvent(event);
    this.setState({'wasReplacementPartCodeChecked': false});

    const sequentialCode = event.target.value;
    if (!sequentialCode) {
      return;
    }

    const {agency} = this.props;
    this.props.fetchReplacementPart(agency, sequentialCode, index);
  }

  onSequenceCodeInputFocus(index) {
    this.props.setCurrentItemIndex(index);
  }

  onSequenceQuantityInputKeyDown(index, {element}, event) {
    if (!(event.keyCode === tabKeyCode || event.keyCode === enterKeyCode)) {
      return;
    }

    stopEvent(event);
    if (
      !this.validateReplacementPartQuantity(element.replacementPartQuantity)
    ) {
      return;
    }

    const {agency} = this.props;
    const data = {'quantity': element.replacementPartQuantity};
    this.props.saveLineInfo(
      {
        agency,
        'sequence': element.orderSequenceCode,
      },
      index,
      data
    );
  }

  validateReplacementPartQuantity(replacementPartQuantity) {
    if (
      !replacementPartQuantity ||
      !Number.isInteger(replacementPartQuantity)
    ) {
      this.props.addMessageBoxError(
        'Debe ingresar un valor entero positvo en el campo Cantidad'
      );
      return false;
    }
    return true;
  }

  selectCode(code) {
    const {currentItem, agency} = this.props;
    const element = document.getElementsByName(
      `items[${currentItem}].replacementPartQuantity`
    )[0];

    this.props.fetchReplacementPart(agency, code, currentItem);
    element.focus();
  }

  showModal() {
    const {agency} = this.props;
    this.setState({'pendingModalOpen': true});
    this.props.fetchScanningPendingItemsList(agency, warehouses.main);
  }

  hideModal() {
    this.setState({'pendingModalOpen': false});
  }

  renderSequenceFieldIcon(savingRow) {
    return (
      <Icon
        name='search'
        color='black'
        link={!savingRow}
        onClick={this.showModal}
      />
    );
  }

  renderTableRows(fields) {
    const {agency, savingLineInfo} = this.props;

    if (!agency) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan='4'>
            Seleccione una Agencia
          </Table.Cell>
        </Table.Row>
      );
    }

    return fields.map((item, index) => {
      const element = fields.get(index);

      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center' className='code-column'>
            <Field
              name={`${item}.orderSequenceCode`}
              component={InputField}
              placeholder='Secuencial'
              disabled={element.itemSaved || savingLineInfo}
              onKeyDown={(event) => this.onSequenceCodeInputKeyDown(index, event)}
              onFocus={() => this.onSequenceCodeInputFocus(index)}
              icon={this.renderSequenceFieldIcon(
                element.itemSaved || savingLineInfo
              )}
              required
              autoFocus
            />
          </Table.Cell>
          <Table.Cell textAlign='center' className='part-code-column'>
            {element.replacementPartCode}
          </Table.Cell>
          <Table.Cell textAlign='center' className='description-column'>
            {element.replacementPartName}
          </Table.Cell>
          <Table.Cell textAlign='center' className='quantity-column'>
            {element.expectedQuantity}
          </Table.Cell>
          <Table.Cell textAlign='center' className='quantity-column'>
            <Field
              name={`${item}.replacementPartQuantity`}
              type='number'
              component={InputField}
              placeholder='Cantidad'
              disabled={
                element.itemSaved ||
                !element.replacementPartCodeChecked ||
                !element.orderSequenceCode ||
                savingLineInfo
              }
              required
              min='1'
              step='1'
              max='9999999999'
              normalize={toInteger}
              onKeyDown={(event) => this.onSequenceQuantityInputKeyDown(index, {
                element,
                fields,
              }, event)}
            />
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  renderLoaderOrTableRows(fields) {
    const {loadingAgencyData} = this.props;
    if (loadingAgencyData) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderTableRows(fields);
  }

  render() {
    const {fields} = this.props;

    return (
      <Table striped className='toyota-grid'>
        <PendingModal
          onOpen={this.onModalOpen}
          onClose={this.hideModal}
          acceptFunction={this.selectCode}
          open={this.state.pendingModalOpen}
          trigger={
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign='center' className='code-column'>
                  Secuencia
                </Table.HeaderCell>
                <Table.HeaderCell
                  textAlign='center'
                  className='part-code-column'
                >
                  Código
                </Table.HeaderCell>
                <Table.HeaderCell
                  textAlign='center'
                  className='description-column'
                >
                  Descripción
                </Table.HeaderCell>
                <Table.HeaderCell
                  textAlign='center'
                  className='quantity-column'
                >
                  Cantidad Pendiente
                </Table.HeaderCell>
                <Table.HeaderCell
                  textAlign='center'
                  className='quantity-column'
                >
                  Cantidad
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
          }
        />

        <Table.Body>{this.renderLoaderOrTableRows(fields)}</Table.Body>
      </Table>
    );
  }
}

const mapStateToProps = (state) => {
  const formValues = formValueSelector(SCANNING_FORM.name);
  const items = formValues(state, 'items');

  return {
    items,
    'loadingAgencyData': state.scanning.loadingAgencyData,
    'agency': state.scanning.agencyData,
    'loadingReplacementPartData': state.scanning.loadingReplacementPartData,
    'replacementPartData': state.scanning.replacementPartData,
    'savingLineInfo': state.scanning.savingLineInfo,
  };
};

const {
  fetchReplacementPart,
  saveLineInfo,
  addMessageBoxError,
  fetchScanningPendingItemsList,
} = Actions;

export default connect(mapStateToProps, {
  fetchReplacementPart,
  saveLineInfo,
  addMessageBoxError,
  fetchScanningPendingItemsList,
})(ScanningTable);
